import axios from "./axiosInstance";
import config from "./config";

const BASE_URL = config.BASE_URL;

// GET notifications
export const getNotifications = (token, { unreadOnly, limit, offset } = {}) => {
  const params = {};
  if (unreadOnly !== undefined) params.unreadOnly = unreadOnly;
  if (limit) params.limit = limit;
  if (offset) params.offset = offset;

  return axios
    .get(`${BASE_URL}/notifications`, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((res) => {
      if (res) return res?.data;
    })
    .catch((err) => {
      return err?.response?.data;
    });
};

// GET unread notification count
export const getUnreadCount = (token) => {
  return axios
    .get(`${BASE_URL}/notifications/unread-count`, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      if (res) return res?.data;
    })
    .catch((err) => {
      return err?.response?.data;
    });
};

// PUT mark notification as read
export const markAsRead = (token, id) => {
  return axios
    .put(`${BASE_URL}/notifications/${id}/read`, {}, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      if (res) return res?.data;
    })
    .catch((err) => {
      return err?.response?.data;
    });
};

// PUT mark all notifications as read
export const markAllAsRead = (token) => {
  return axios
    .put(`${BASE_URL}/notifications/read-all`, {}, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      if (res) return res?.data;
    })
    .catch((err) => {
      return err?.response?.data;
    });
};

// DELETE notification
export const deleteNotification = (token, id) => {
  return axios
    .delete(`${BASE_URL}/notifications/${id}`, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      if (res) return res?.data;
    })
    .catch((err) => {
      return err?.response?.data;
    });
};

// POST trigger overdue action emails (admin only)
export const sendOverdueEmails = (token, tenantSlug) => {
  return axios
    .post(`${BASE_URL}/notifications/send-overdue-emails`, {}, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${token}`,
        "x-tenant-slug": tenantSlug,
      },
    })
    .then((res) => {
      if (res) return res?.data;
    })
    .catch((err) => {
      return err?.response?.data;
    });
};
